import { render, staticRenderFns } from "./Fandom.vue?vue&type=template&id=1149dd77&scoped=true"
import script from "./Fandom.vue?vue&type=script&lang=js"
export * from "./Fandom.vue?vue&type=script&lang=js"
import style0 from "./Fandom.vue?vue&type=style&index=0&id=1149dd77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1149dd77",
  null
  
)

export default component.exports